import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AngularFireAuth } from '@angular/fire/auth';

import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';

import { AuthService } from "../../core/auth.service";
import { Router, Params, ActivatedRoute } from '@angular/router';

@Component({
    selector     : 'login-2',
    templateUrl  : './login-2.component.html',
    styleUrls    : ['./login-2.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})
export class Login2Component implements OnInit
{
    loginForm: FormGroup;
    errorMessage: string = '';
    successMessage: string = '';

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private _fuseConfigService: FuseConfigService,
        private _formBuilder: FormBuilder,
        private fire: AngularFireAuth,
        private _authService: AuthService
    )
    {
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar   : {
                    hidden: true
                },
                toolbar  : {
                    hidden: true
                },
                footer   : {
                    hidden: true
                },
                sidepanel: {
                    hidden: true
                }
            }
        };
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        this.loginForm = this._formBuilder.group({
            email   : ['', [Validators.required, Validators.email]],
            password: ['', Validators.required]
        });

        this.route.params.subscribe(params => {
            if (params['id']) {
                const decodeText = atob(params['id']);
                if ( decodeText === 'success_create_account') {
                    this.successMessage = "Tu cuenta ha sido creada exitosamente, ahora puedes entrar"
                }

            }
        })
    }

    tryLogin(value){
        this._authService.doLogin(value)
        .then(res => {
            this.fire.authState.subscribe(auth => {
                if (auth) {
                    localStorage.setItem('uid', auth.uid)
                }
            })
          this.router.navigate(['/dashboard']);
        }, err => {
          console.log(err);
          this.errorMessage = err.message;
        })
      }

    tryFacebookLogin() {
        this._authService.doFacebookLogin()
            .then(res => {
                this.fire.authState.subscribe(auth => {
                    if (auth) {
                        localStorage.setItem('uid', auth.uid)
                    }
                })
                this.router.navigate(['/gastos/finanzas/cuentas']);
            }, err => console.log(err)
            )
    }

    tryGoogleLogin() {
        this._authService.doGoogleLogin()
            .then(res => {
                this.fire.authState.subscribe(auth => {
                    if (auth) {
                        localStorage.setItem('uid', auth.uid)
                    }
                })
                this.router.navigate(['/gastos/finanzas/cuentas']);
            }, err => console.log(err)
            )
    }
}
